export default {
    gqlUrl: 'https://jotun-kompetanse-api-v2.allemuligheter.no/graphql',
    imageUrl: ''
}